import { Navigate, useLocation } from "react-router-dom";
import useIsAuth from "../../hooks/useIsAuth";
export const ProtectedRouteStudent = ({ children }) => {
  const isAuth = useIsAuth();
  const location = useLocation();
  const navigateLocation = location.state;
  if (navigateLocation) {
    window.location.href = navigateLocation;
    return;
  }

  if (!isAuth) {
    // user is not authenticated
    return <Navigate to="/" state={window.location.href} />;
  }
  return children;
};
